import { styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { DatePicker } from 'thermia-react-container';

const StyledDatePickerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));

export type DateRange = {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

type DateRangeProps = {
  startDate: moment.Moment;
  endDate: moment.Moment;
  minDate: moment.Moment;
  maxDate: moment.Moment;
  onChange: (range: { startDate: moment.Moment; endDate: moment.Moment }) => void;
};

export const GetDateRangeFromDateTimeOffsets = (dates: string[]): DateRange => {
  // Use ISO format for moment construction
  dates = dates.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
  return dates.length > 0
    ? { startDate: DateTimeOffsetToMoment(dates[0]), endDate: DateTimeOffsetToMoment(dates[dates.length - 1]) }
    : { startDate: DateTimeOffsetToMoment('2001-01-01T00:00:00+00:00'), endDate: moment() };
}

export const DateTimeOffsetToMoment = (dateTimeOffset: string | undefined): moment.Moment => {
  return moment(dateTimeOffset, moment.ISO_8601, true);
}

const DateRangeFilter: React.FC<DateRangeProps> = ({ startDate, endDate, minDate, maxDate, onChange }) => {
  const { t } = useTranslation('registrations');

  const handleOnChangeStartDate = (value: string) => {
    onChange({ startDate: moment(value, moment.ISO_8601, true), endDate });
  };

  const handleOnChangeEndDate = (value: string) => {
    onChange({ startDate, endDate: moment(value, moment.ISO_8601, true) });
  };

  return (
    <StyledDatePickerContainer>
      <DatePicker
        label={t('registrations.general.startDate')}
        value={startDate.format('YYYY-MM-DD')}
        onChange={handleOnChangeStartDate}
        minDate={minDate}
        maxDate={maxDate}
      />
      <DatePicker
        label={t('registrations.general.endDate')}
        value={endDate.format('YYYY-MM-DD')}
        onChange={handleOnChangeEndDate}
        minDate={minDate}
        maxDate={maxDate}
      />
    </StyledDatePickerContainer>
  );
};

export default DateRangeFilter;
